import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TickInCircleSystemIcon, InfoSystemIcon, WarningSystemIcon, CrossInCircleSystemIcon } from '@nib/icons';
export const pickBorderColor = alertType => {
  switch (alertType) {
    case 'info':
    default:
      return 'var(--themeColorBorderInfo,#005bb9)';
    case 'error':
      return 'var(--themeColorBorderError,#c81414)';
    case 'success':
      return 'var(--themeColorBorderSuccess,#007800)';
    case 'warning':
      return 'var(--themeColorBorderWarning,#ffb400)';
  }
};
export const pickBackgroundColor = alertType => {
  switch (alertType) {
    case 'info':
    default:
      return 'var(--alertColorBgInfo,#ebf2fa)';
    case 'error':
      return 'var(--alertColorBgError,#fcedeb)';
    case 'success':
      return 'var(--alertColorBgSuccess,#ebf6ee)';
    case 'warning':
      return 'var(--alertColorBgWarning,#fff9eb)';
  }
};
export const pickIconColor = alertType => {
  switch (alertType) {
    case 'info':
    default:
      return 'var(--themeColorFgInfo,#005bb9)';
    case 'error':
      return 'var(--themeColorFgError,#c81414)';
    case 'success':
      return 'var(--themeColorFgSuccess,#007800)';
    case 'warning':
      return 'var(--themeColorFgWarning,#444444)';
  }
};
export const renderIcon = type => {
  const fill = pickIconColor(type);
  switch (type) {
    case 'info':
    default:
      return /*#__PURE__*/_jsx(InfoSystemIcon, {
        fill: fill
      });
    case 'error':
      return /*#__PURE__*/_jsx(CrossInCircleSystemIcon, {
        fill: fill
      });
    case 'success':
      return /*#__PURE__*/_jsx(TickInCircleSystemIcon, {
        fill: fill
      });
    case 'warning':
      return /*#__PURE__*/_jsx(WarningSystemIcon, {
        fill: fill
      });
  }
};